import React, { useEffect, useRef, useState } from "react";
export const ArchivedProject = (props) => {
  const [isIntersecting, setIsIntersecting]=useState(false)
  const ref=useRef(null);

  useEffect(()=>{
    const observer=new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          setIsIntersecting(true)
        }
        else{
          setIsIntersecting(false)
        }
      })
    })
  
    observer.observe(ref.current);
    return ()=>observer.disconnect();
  },[])
  
  
  return (
      <div className="archivedProjectFolder">
        <h4>{props.title}</h4>
        <div className="folder" ref={ref}>
          <div className="back"></div>
          <div className={isIntersecting?"paper paper-animation-start":"paper "}></div>
          <div className="paper"></div>
          <div className={isIntersecting?"cover animation-start":"cover"}></div>
        </div>
        <div>
            <p>{props.content1}</p>
            <p>{props.content2}</p>
            <p>{props.content3}</p>
            {props?.githubLink && <a href={props.githubLink}><svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-github"><title>GitHub</title><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg></a>}
            {props?.websiteLink && <a href={props.websiteLink} className="websiteLink"><svg width="800px" height="800px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="#000000" fill="none"><path d="M39.93,55.72A24.86,24.86,0,1,1,56.86,32.15a37.24,37.24,0,0,1-.73,6"/><path d="M37.86,51.1A47,47,0,0,1,32,56.7"/><path d="M32,7A34.14,34.14,0,0,1,43.57,30a34.07,34.07,0,0,1,.09,4.85"/><path d="M32,7A34.09,34.09,0,0,0,20.31,32.46c0,16.2,7.28,21,11.66,24.24"/><line x1="10.37" y1="19.9" x2="53.75" y2="19.9"/><line x1="32" y1="6.99" x2="32" y2="56.7"/><line x1="11.05" y1="45.48" x2="37.04" y2="45.48"/><line x1="7.14" y1="32.46" x2="56.86" y2="31.85"/><path d="M53.57,57,58,52.56l-8-8,4.55-2.91a.38.38,0,0,0-.12-.7L39.14,37.37a.39.39,0,0,0-.46.46L42,53.41a.39.39,0,0,0,.71.13L45.57,49Z"/></svg></a>}
        </div>
      </div>
  );
};
